export const useFormStoreRadixOverlay = (isOpen: MaybeRefOrGetter<boolean>) => {
  const formStore = useFormStore()
  const isRegistered = ref(false)

  const update = (open: boolean) => {
    if (open && !isRegistered.value) {
      formStore.registerRadixOverlay()
      isRegistered.value = true
      return
    }

    if (!open && isRegistered.value) {
      formStore.unregisterRadixOverlay()
      isRegistered.value = false
    }
  }

  watch(() => toValue(isOpen), update, { immediate: true })

  onScopeDispose(() => {
    update(false)
  })
}
